/* @flow */

export const StepState = {
  NOT_STARTED: 'NOT_STARTED',
  COMPLETE: 'COMPLETE',
  STARTED: 'STARTED',
  ERROR: 'ERROR',
  DISABLED: 'DISABLED',
};

export const Steps = {
  STEP_ONE: 'STEP_ONE',
  STEP_ANALYSIS: 'STEP_ANALYSIS',
  REPORT: 'REPORT',
};

export const defaults = {
  DECIMAL_PLACES: 5,
  EXP_THRESHOLD: 5,
};



// WEBPACK FOOTER //
// ./src/utils/constants.js